module.exports = __webpack_public_path__ + "img/quberlogo.59a4d53f.png";